import adpater from './adapter'
import { initialPaginationState } from '@/store/pagination'

export default {
  resume: null,
  collection: adpater.getInitialState(),
  pagination: initialPaginationState(),
}
